import React from 'react';
import { Container, Jumbotron } from 'reactstrap';

export const Imprint: React.FC = () => {
  return (
    <Jumbotron className="mb-4">
      <Container className="p-4" fluid>
        <h1>Impressum</h1>
        <p>https://info.bml.gv.at/themen/wasser/wisa/impressum.html</p>
      </Container>
    </Jumbotron>
  );
};
